import { render } from "./AgencyEmailTemplates.vue?vue&type=template&id=aae0e90c&scoped=true"
import script from "./AgencyEmailTemplates.vue?vue&type=script&lang=js"
export * from "./AgencyEmailTemplates.vue?vue&type=script&lang=js"

import "./AgencyEmailTemplates.vue?vue&type=style&index=0&id=aae0e90c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae0e90c"]])

export default __exports__